import React from "react";
import { ContactInfoFormStyled } from "./contact-info-form.style";
import SelectFormField from "../../components/form-fields/select-field/select-form-field";
import { TextInputFormField } from "../../components/form-fields/text-input-field/text-input-form-field";
import {
  CONTACT_STATES_OPTIONS,
  CONTACT_TYPE_OPTIONS,
} from "../../constants/constants";
import useCompanies from "../../hooks/useCompanies";

export const Contact_INFO_FORM_VIEW_TYPES = {
  detail: "detail",
  creation: "creation",
};

const ContactInfoForm = ({ form, view = "creation", disableCompanyName }) => {
  const { control, getValues, watch } = form;
  watch();
  const formData = getValues();
  const isDetailedView = view === Contact_INFO_FORM_VIEW_TYPES?.detail;
  const isCreationView = view === Contact_INFO_FORM_VIEW_TYPES.creation;

  const { companies } = useCompanies();
  const companyOptions =
    companies
      ?.map((company) => ({
        label: company.companyName,
        value: company.id,
      }))
      ?.sort((a, b) => a.label.localeCompare(b.label)) || [];

  const renderFieldsBasedOnView = () => {
    if (isCreationView) {
      return (
        <ContactInfoFormStyled isDetailedView={isDetailedView}>
          <div className="creation-template">
            <div>
              <div className="flexCreate">
                <TextInputFormField
                  isRequired
                  label="First Name"
                  placeholder="First Name"
                  name={"firstName"}
                  control={control}
                  defaultValue={formData?.firstName}
                />
                <TextInputFormField
                  isRequired
                  label="Last Name"
                  placeholder="Last Name"
                  name={"lastName"}
                  control={control}
                  defaultValue={formData?.lastName}
                />
              </div>
              <div className="flexCreate">
                <TextInputFormField
                  isRequired
                  label="Title"
                  placeholder="Company Role"
                  name={"title"}
                  control={control}
                  defaultValue={formData?.title}
                />
                <SelectFormField
                  control={control}
                  name="companyID"
                  label="Company"
                  placeholder="Please Select"
                  options={companyOptions}
                  disabled={disableCompanyName}
                  isRequired
                />
              </div>
              <div className="flexCreate">
                <SelectFormField
                  control={control}
                  isRequired
                  name="type"
                  label="Type"
                  placeholder="Select.."
                  options={CONTACT_TYPE_OPTIONS}
                />
                <SelectFormField
                  isRequired
                  control={control}
                  name="contactState"
                  label="State"
                  placeholder="Please Select"
                  options={CONTACT_STATES_OPTIONS}
                />
              </div>
              <hr className="hr"></hr>
              <div className="flexCreate">
                <TextInputFormField
                  isRequired
                  label="Email Address"
                  placeholder="email@address.com"
                  name={"emailAddress"}
                  control={control}
                />
                <TextInputFormField
                  isRequired
                  label="Phone Number"
                  placeholder="1 (123) 456-7890"
                  name={"phoneNumber"}
                  control={control}
                />
              </div>
            </div>
            <div style={{ gap: "10px", display: "grid" }}>
              <hr className="hr"></hr>
              <TextInputFormField
                multiline
                rows={5}
                label={"Contact Notes"}
                placeholder={"Type your message..."}
                name={"contactNotes"}
                control={control}
                description={
                  "Notes are for internal use only and will not appear on outward-facing materials."
                }
              />
            </div>
          </div>
        </ContactInfoFormStyled>
      );
    }

    if (isDetailedView) {
      return (
        <ContactInfoFormStyled isDetailedView={isDetailedView}>
          <div className="detail-template">
            <div className="left-content">
              <div className="flex">
                <TextInputFormField
                  isRequired
                  label="First Name"
                  name={"firstName"}
                  control={control}
                  defaultValue={formData?.firstName}
                />
                <TextInputFormField
                  isRequired
                  label="Last Name"
                  name={"lastName"}
                  control={control}
                  defaultValue={formData?.lastName}
                />
              </div>
              <div className="flex">
                <TextInputFormField
                  isRequired
                  label="Title"
                  name={"title"}
                  control={control}
                  defaultValue={formData?.title}
                />
                <SelectFormField
                  control={control}
                  name="companyID"
                  isRequired
                  label="Company"
                  placeholder="Please Select"
                  options={companyOptions}
                />
              </div>
              <div className="flex">
                <SelectFormField
                  control={control}
                  isRequired
                  name="type"
                  label="Type"
                  placeholder="Select.."
                  options={CONTACT_TYPE_OPTIONS}
                />
                <SelectFormField
                  isRequired
                  control={control}
                  name="contactState"
                  label="State"
                  placeholder="Please Select"
                  options={CONTACT_STATES_OPTIONS}
                />
              </div>
              <hr className="hr"></hr>
              <div className="flex">
                <TextInputFormField
                  isRequired
                  label="Email Address"
                  name={"emailAddress"}
                  control={control}
                />
                <TextInputFormField
                  isRequired
                  label="Phone Number"
                  placeholder="1 (123) 456-7890"
                  name={"phoneNumber"}
                  control={control}
                />
              </div>
            </div>
            <div className="notes">
              <TextInputFormField
                multiline
                rows={15}
                label={"Contact Notes"}
                name={"contactNotes"}
                control={control}
                description={
                  "Notes are for internal use only and will not appear on outward-facing materials."
                }
              />
            </div>
          </div>
        </ContactInfoFormStyled>
      );
    }

    return null;
  };

  return (
    <ContactInfoFormStyled>
      <div className="project-cont">
        <div className="row-style">{renderFieldsBasedOnView()}</div>
      </div>
    </ContactInfoFormStyled>
  );
};

export default ContactInfoForm;
